
import { useEffect } from "react"
import { useDispatch } from "react-redux"
import AttorneyDetail from "./AttorneyDetail"
import AttorneyTabControls from "./AttorneyTabControls"
import TabHeader from "../../tab/TabHeader"
import NotesComponent from "../notes/NotesComponent"
import { attorneyActions } from "../../../../store/attorneys"
import ItemsCounter from "../Shared/ItemsCounter"
import classes from '../Shared/Container.module.css'

const AttorneyTab = ({ inWorkQ }) => {

    const dispatch = useDispatch()

    useEffect(() => {
        return () => {
            dispatch(attorneyActions.setSearchResult(null))
            dispatch(attorneyActions.setClearAsyncResults(false))
        }
    }, [])

    return <>
        <TabHeader>
            <div className="flex-container">
                <h2>Attorney</h2>
                <ItemsCounter type={'attorneys'}/>
                <NotesComponent noteTypeId={1} inWorkQ={inWorkQ}/>
            </div>
            <AttorneyTabControls apiCase={'case_attorney'}/>
        </TabHeader>
        <div className={classes.container}>
            <AttorneyDetail />
        </div>
    </>
}

export default AttorneyTab